import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { TypeAnimation } from "react-type-animation";
import Breadcrumb from "../components/Breadcrumb";
import "./Pages.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    email: "",
    phone: "",
    enquiryType: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: "Enquiry: " + (formData.enquiryType || "General"),
        message: "Organization: " + formData.organization + "\nEnquiry Type: " + formData.enquiryType + "\n\nMessage: " + formData.message,
      };
      const res = await fetch("/morphis_backend/api.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.error || "Failed to send message");
      setSubmitted(true);
      setFormData({
        name: "",
        organization: "",
        email: "",
        phone: "",
        enquiryType: "",
        message: "",
      });
    } catch (err) {
      alert(err.message || "Failed to send message. Please try again.");
    }
  };

  return (
    <>
      <Breadcrumb />

      <section className="contact-page">
        <div className="museum-wrap">
          <div className="contact-container">

            {/* LEFT SIDE */}
            <div className="contact-info" data-aos="fade-right">
              <span className="eyebrow">Get in Touch</span>

              <h1>
                Let's <br />
                <em><TypeAnimation
                                    sequence={["Connect"]}
                                    speed={250}
                                    cursor={false}
                                  /></em>
              </h1>

              <p className="contact-desc">
                Morphis partners with investors and leadership teams on
                execution-critical work. To explore a potential engagement,
                reach us directly or use the form.
              </p>

              <div className="contact-details">

                <div className="contact-item" data-aos="fade-up" data-aos-delay="100">
                  <div className="contact-icon">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <div>
                    <span className="contact-label">Email</span>
                    <a
                      href="mailto:vinni.rajani@morphis.co.in"
                      className="contact-value"
                    >
                      vinni.rajani@morphis.co.in
                    </a>
                  </div>
                </div>

                {/*<div className="contact-item" data-aos="fade-up" data-aos-delay="200">
                  <div className="contact-icon">
                    <i className="fa fa-phone"></i>
                  </div>
                  <div>
                    <span className="contact-label">Phone</span>
                    <a href="tel:+919820387850" className="contact-value">
                      +91 98203 87850
                    </a>
                  </div>
                </div>*/}

                <div className="contact-item" data-aos="fade-up" data-aos-delay="300">
                  <div className="contact-icon">
                    <i className="fa fa-location-dot"></i>
                  </div>
                  <div>
                    <span className="contact-label">Our office</span>
                    <span className="contact-value">
                      401, 4th Floor, Kakad Chambers, 132, Dr. Annie Besant Road,
                      Worli, Mumbai 400018
                    </span>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT SIDE FORM */}
            <div className="contact-form-card" data-aos="fade-left">

              {submitted ? (
                <div style={{ textAlign: "center", padding: "60px 20px" }}>
                  <h2 style={{ fontSize: "1.8rem", marginBottom: "16px" }}>Thank you!</h2>
                  <p style={{ color: "#666", marginBottom: "24px", lineHeight: "1.7" }}>
                    Your message has been sent. We will get back to you within 24-48 hours.
                  </p>
                  <button
                    className="submit-btn"
                    onClick={() => setSubmitted(false)}
                  >
                    Send Another Message <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              ) : (

              <form onSubmit={handleSubmit}>

                <div className="form-row">

                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Organization</label>
                    <input
                      type="text"
                      name="organization"
                      value={formData.organization}
                      onChange={handleChange}
                    />
                  </div>

                </div>

                <div className="form-row">

                  <div className="form-group">
                    <label>Contact Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                </div>

                <div className="form-group">
                  <label>Enquiry Type</label>
                  <select
                    name="enquiryType"
                    value={formData.enquiryType}
                    onChange={handleChange}
                  >
                    <option value="">Select an option</option>
                    <option value="connect">
                      Would like to connect as new client
                    </option>
                    <option value="career">
                      Build a career with Morphis
                    </option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Message</label>
                  <textarea
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about the engagement, context, timeline, and outcome…"
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Send Message <i className="fa fa-arrow-right"></i>
                </button>

              </form>

              )}

            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;